import React from 'react';
import Inventario from '../../../components/insumos/informes/Inventario';
import { PageWrapper } from '../../../components/common';

const InventarioPage: React.FC = () => {
  return (
    <PageWrapper>
      <Inventario />
    </PageWrapper>
  );
};

export default InventarioPage;
